"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.createAppStore = void 0;
const toolkit_1 = require("@reduxjs/toolkit");
const gameListeners_1 = require("~/listeners/gameListeners");
const state_1 = require("./game/state");
const state_2 = require("./lobby/state");
const state_3 = require("./menu/state");
const createAppStore = (extra) => {
    const listenerMiddleware = (0, toolkit_1.createListenerMiddleware)({ extra });
    const store = (0, toolkit_1.configureStore)({
        reducer: {
            lobby: state_2.lobbyReducer,
            game: (0, state_1.createGameReducer)(),
            menu: state_3.menuReducer,
        },
        middleware: (getDefaultMiddleware) => getDefaultMiddleware({
            thunk: false,
            serializableCheck: false,
        }).prepend(listenerMiddleware.middleware),
        devTools: {
            trace: true,
            traceLimit: 20,
        },
    });
    (0, gameListeners_1.setupGameListeners)(listenerMiddleware.startListening);
    return store;
};
exports.createAppStore = createAppStore;
